import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/pages/home/Home'
// import PrimarySchool from '@/pages/primaryschool/PrimarySchool'
// import MiddleSchool from '@/pages/middleschool/Middleschool'

Vue.use(Router)

export default new Router({
  mode: 'history'
  // routes: [
  //   {
  //     path: '/',
  //     name: 'Home',
  //     component: Home
  //   },
  //   {
  //     path: '/primaryschool',
  //     name: 'PrimarySchool',
  //     component: PrimarySchool
  //   },
  //   {
  //     path: '/middleschool',
  //     name: 'MiddleSchool',
  //     component: MiddleSchool
  //   }
  // ]
})



// WEBPACK FOOTER //
// ./src/router/index.js